import { React, useState, useEffect, useRef } from "react";
import AddSupplier from "./add-supplier";
import "./supplier.scss";
import {
  Button,
  Space,
  Card,
  Tag,
  Row,
  Col,
  Typography,
  Spin,
  Input,
  Tabs,
} from "antd";
import clockImg from "../../assets/images/clock-01.svg";
import MapButtonIcon from "../../assets/images/maps-square-button.svg";
import currentLocation from "../../assets/images/current-location-img.svg";
import movingCircle from "../../assets/images/moving-circle-arrow-reload.svg";
import TruckWithBox from "../../assets/images/truck-with-box.svg";
import TruckWithGrill from "../../assets/images/Grill-truck.svg";
import EmptyTruck from "../../assets/images/Flatted-truck.svg";
import TruckNumImg from "../../assets/images/truck-num-img.svg";
import infromationCircle from "../../assets/images/information-circle-fleet.svg";
import TruckPhoneImg from "../../assets/images/phone-img.svg";
import NodataImg from "../../assets/images/nodata-img.svg";
import NextArrowGrey from "../../assets/images/arrow-right-grey.svg";
import NextArrowGreen from "../../assets/images/arrow-right-green.svg";
import NextArrowBlack from "../../assets/images/arrow-black.svg";
import EditIcon from "../../assets/images/edit-icon-orange.svg";
import DriverGruardImg from "../../assets/images/driver-guard-img.svg";
import PlusIcon from "../../assets/images/plus-icon.png";
import AscDecIcon from "../../assets/images/asc-dec-icon.svg";
import filterSortIcon from "../../assets/images/filter-arrow-down.svg";
import LoadingImg from "../../assets/images/loading-02.svg";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import AddTruck from "./add-truck";
import AddDriver from "./add-driver";
import * as driverService from "../../service/fleet-management/driverService";
import * as truckService from "../../service/fleet-management/truckService";
import * as supplierService from "../../service/fleet-management/supplierService";
import Notification from "../../service/notification";
import { SearchOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { OwnerType } from "../../constants/commonConstants";
import { useStore } from "../../store/store";

const { Text } = Typography;
const { TabPane } = Tabs;

const Supplier = () => {
  const { t } = useTranslation();
  const [addSupplierModalOpen, setAddSupplierModalOpen] = useState(false);
  const [trackingType, setTrackingtype] = useState("onTrip");
  const [supplierData, setSupplierData] = useState([]);
  const navigate = useNavigate();
  const [pageSize, setPageSize] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [hasMoreData, setHasMoreData] = useState(true);
  const [loading, setLoading] = useState(false);
  const [trackingData, setTrackingData] = useState([]);
  const observerRef = useRef();
  const searchTimeoutRef = useRef(null);
  const { user, saveUser } = useStore();
  const [currentTab, setCurrentTab] = useState("All");
  const [sortOrder, setSortOrder] = useState("asc");
  const [isSortApplied, setIsSortApplied] = useState(false);

  const statusTabs = [
    { key: "All", label: "All" },
    { key: "DetailsSubmitted", label: "Details Submitted" },
    { key: "DetailsPending", label: "Details Pending" },
    { key: "OTPverificationpending", label: "OTP Verification Pending" },
    { key: "Approved", label: "Approved" },
    { key: "Rejected", label: "Rejected" },
    { key: "Expired", label: "Expired" },
    { key: "Banned", label: "Banned" },
  ];
  // Remove duplicate useEffect hooks and combine the logic
  useEffect(() => {
    if (!loading) {
      getSupplierData();
    }
  }, [currentPage, currentTab, sortOrder]);
  useEffect(() => {
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    searchTimeoutRef.current = setTimeout(() => {
      setCurrentPage(1);
      setHasMoreData(true);
      setSupplierData([]);
      getSupplierData();
    }, 500);

    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, [searchValue]);

  // Intersection Observer for infinite scroll
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasMoreData && !loading) {
          setCurrentPage((prev) => prev + 1);
        }
      },
      { threshold: 0.1 }
    );

    if (observerRef.current) {
      observer.observe(observerRef.current);
    }

    return () => {
      if (observerRef.current) observer.unobserve(observerRef.current);
    };
  }, [hasMoreData, loading]);

  const getSupplierData = () => {
    if (loading) return; // Prevent duplicate calls while loading

    setLoading(true);
    let payload = {
      pageSize: pageSize,
      pageNumber: currentPage,
      search: searchValue,
      sortBy: "name",
      sortOrder: sortOrder,
    };

    if (currentTab !== "All") {
      payload.status = currentTab;
    }

    console.log("ssssValue", payload);

    supplierService
      .getFleetSupplierList(payload)
      .then((response) => {
        setLoading(false);
        if (response.status == 200) {
          setSupplierData((prevData) => [...prevData, ...response?.data?.data]);
          setHasMoreData(
            response.data.pagination.pageNumber <
              response.data.pagination.totalPages
          );
        }
      })
      .catch((error) => {
        setLoading(false);
        setHasMoreData(false);
      });
  };

  const handleSearchChange = (e) => {
    const value = e.target.value.trim();
    setSearchValue(value);
    if (value.length >= 3 || value.length === 0) {
      setSupplierData([]);
      setCurrentPage(1);
      setHasMoreData(true);
    }
  };

  const handleSort = () => {
    setSortOrder((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
    setIsSortApplied(!isSortApplied);
  };

  const supplierLists = (supplierData) => {
    return (
      <>
        {loading && supplierData?.length === 0 ? (
          <div className="loading">
            <Spin />
          </div>
        ) : (
          <>
            {supplierData?.length > 0 ? (
              <>
                <div className="scroll-continer-drivers">
                  <Row gutter={[16, 0]}>
                    {supplierData?.map((supplier, index) => {
                      return (
                        <Col
                          span={
                            user?.userRole == OwnerType.INTERNAL_SOURCE &&
                            !searchValue
                              ? 6
                              : 8
                          }
                          key={index}
                        >
                          <div className="left-card-driver">
                            <Row>
                              <div
                                className={
                                  supplier.statusText === "Available"
                                    ? "available-status"
                                    : supplier.statusText === "Booked"
                                    ? "booked-status"
                                    : "warning-status"
                                }
                              >
                                {supplier.statusText}
                              </div>

                              {/* <span className="driver-num"><img  src={EditIcon} alt='alt'  onClick={()=>navigate(`/supplier-detail/${supplier.supplierId}`)}/></span> */}
                              <span
                                className="driver-num"
                                onClick={() =>
                                  navigate(
                                    `/supplier-detail/${supplier.supplierId}`
                                  )
                                }
                              >
                                <img src={infromationCircle} alt="view" />
                              </span>
                            </Row>

                            <div
                              className="driver-card-row-supplier"
                              onClick={async () => {
                                navigate(
                                  `/supplier-fleet/${supplier.supplierId}/${supplier.name}`,
                                  {
                                    state: {
                                      userRole: supplier?.userRole,
                                      operatingCountry:
                                        supplier?.operatingCountry,
                                    },
                                  }
                                );
                              }}
                            >
                              <div className="driverName-supplierCard">
                                <img
                                  src={DriverGruardImg}
                                  alt="alt"
                                  className="img-size-driver"
                                />
                                <div className="driver-detail">
                                  <Text
                                    style={{ width: "150px" }}
                                    ellipsis={{ tooltip: true }}
                                  >
                                    {supplier.name}
                                  </Text>
                                  <span>
                                    <img src={TruckPhoneImg} />
                                    <span>
                                      +{supplier.countryCode}{" "}
                                      {supplier.mobileNo}
                                    </span>
                                  </span>
                                </div>
                              </div>
                              <span className="driver-num">
                                {supplier.userRole === OwnerType.FLEET_OWNER
                                  ? "Fleet Owner"
                                  : supplier.userRole === OwnerType.BROKER
                                  ? "Broker"
                                  : supplier.userRole ===
                                    OwnerType.FLEET_OWNER_C
                                  ? "Fleet Owner C"
                                  : "STO"}
                              </span>
                            </div>
                            {/* <hr style={{borderTop:"dotted 2px",width:"19rem",color:"var(--text-faint, #858C9480)"}} /> */}
                            <div className={"last-update-driver-warning"}>
                              <Row>
                                <Col span={23}>
                                  <Col>
                                    {supplier?.userRole ==
                                    OwnerType.FLEET_OWNER ? (
                                      <>
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          <div
                                            style={{
                                              color: "var(--text-subtle, #545D69B2)",
                                              fontSize: "12px",
                                              fontWeight: "bold",
                                              paddingRight: "2px",
                                            }}
                                          >
                                            {t("LOADS_TAX_ID")}:
                                          </div>
                                          <Text
                                            style={{
                                              color: "var(--text-subtle, #545D69B2)",
                                              fontSize: "14px",
                                              width: "100px",
                                            }}
                                            ellipsis={{ tooltip: true }}
                                          >
                                            {supplier.taxId
                                              ? supplier.taxId
                                              : "NA"}
                                          </Text>
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          <div
                                            style={{
                                              color: "var(--text-subtle, #545D69B2)",
                                              fontSize: "12px",
                                              fontWeight: "bold",
                                              paddingRight: "2px",
                                            }}
                                          >
                                            {t("FLEET_DRIVER_DRIVING_LICENSE")}:
                                          </div>
                                          <Text
                                            style={{
                                              color: "var(--text-subtle, #545D69B2)",
                                              fontSize: "14px",
                                              width: "100px",
                                            }}
                                            ellipsis={{ tooltip: true }}
                                          >
                                            {supplier.drivingLicenseId
                                              ? supplier.drivingLicenseId
                                              : "NA"}
                                          </Text>
                                        </div>
                                      </>
                                    )}
                                  </Col>
                                  <Col
                                    onClick={async () => {
                                      navigate(
                                        `/supplier-fleet/${supplier.supplierId}/${supplier.name}`,
                                        {
                                          state: {
                                            userRole: supplier?.userRole,
                                            operatingCountry:
                                              supplier?.operatingCountry,
                                          },
                                        }
                                      );
                                    }}
                                  >
                                    {supplier?.userRole == OwnerType.STO && (
                                      <>
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          <div
                                            style={{
                                              color: "var(--text-subtle, #545D69B2)",
                                              fontSize: "12px",
                                              fontWeight: "bold",
                                              paddingRight: "2px",
                                            }}
                                          >
                                            {t("FLEET_DRIVER_NATIONAL_ID")}:
                                          </div>
                                          <Text
                                            style={{
                                              color: "var(--text-subtle, #545D69B2)",
                                              fontSize: "14px",
                                              width: "100px",
                                            }}
                                            ellipsis={{ tooltip: true }}
                                            className=""
                                          >
                                            {supplier.nationalId
                                              ? supplier.nationalId
                                              : "NA"}
                                          </Text>
                                        </div>
                                      </>
                                    )}
                                  </Col>
                                </Col>
                                <Col
                                  span={1}
                                  onClick={async () => {
                                    navigate(
                                      `/supplier-fleet/${supplier.supplierId}/${supplier.name}`,
                                      {
                                        state: {
                                          userRole: supplier?.userRole,
                                          operatingCountry:
                                            supplier?.operatingCountry,
                                        },
                                      }
                                    );
                                  }}
                                >
                                  <img src={NextArrowBlack} alt="alt" />
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                  {loading && (
                    <div className="loading">
                      <Spin />
                    </div>
                  )}
                  {hasMoreData && (
                    <div ref={observerRef} className="load-more">
                      {" "}
                      <img src={LoadingImg} alt="loading" /> Loading more
                      suppliers..{" "}
                    </div>
                  )}
                </div>
              </>
            ) : (
              <Row justify={"center"} className="no-data">
                <img src={NodataImg} alt="no data" />
              </Row>
            )}
          </>
        )}
      </>
    );
  };

  const tabItems = statusTabs.map(({ key, label }) => ({
    key,
    label: t(label),
    children: supplierLists(supplierData),
  }));

  const handleCloseModal = () => {
    setAddSupplierModalOpen(false);
  };

  const onTabChange = (key) => {
    setCurrentTab(key);
    setSupplierData([]);
    setSearchValue("");
    setHasMoreData(true);
    setCurrentPage(1);
  };

  return (
    <div className="supplier-wrapper">
      <div
        className="suppliers"
        style={{
          width: !user?.userRole == OwnerType.INTERNAL_SOURCE ? "70%" : "100%",
        }}
      >
        <Row className="suppliers-space" justify={"space-between"}>
          <Space>
            <Input
              placeholder={t("FLEET_SEARCH_PH")}
              prefix={<SearchOutlined />}
              className="search-input"
              onChange={handleSearchChange}
              value={searchValue}
            />
            <Button
              onClick={handleSort}
              className={isSortApplied ? "sort-btn-active" : ""}
            >
              <img src={isSortApplied ? filterSortIcon : AscDecIcon} />
            </Button>
            <Button
              className="add-btn"
              onClick={() => setAddSupplierModalOpen(!addSupplierModalOpen)}
            >
              {" "}
              <img src={PlusIcon} /> {t("ADD_SUPPLIER_COMMON")}
            </Button>
          </Space>
        </Row>
        <>
          <Tabs
            items={tabItems}
            activeKey={currentTab}
            defaultActiveKey="All"
            onChange={onTabChange}
          />
        </>
        {/* <Row style={{marginTop:'1rem'}}><span style={{fontSize:"16px",fontWeight:'bold'}}>{t("SUPPLIER_AVAILABLE_SUPPLIER")}</span></Row> */}
      </div>
      {!user?.userRole == OwnerType.INTERNAL_SOURCE && (
        <div className="truck-tracking">
          <Space className="track-title">
            <span>{t("FLEET_TRUCKS_TRUCK_TRACKING")}</span>
            <Button icon={<img src={MapButtonIcon} alt="alt" />}>
              {t("FLEET_TRUCKS_MAP_VIEW")}
            </Button>
          </Space>
          <div className="trip-detail">
            <p
              onClick={() => setTrackingtype("onTrip")}
              className={trackingType === "onTrip" ? "active" : "in-active"}
            >
              {t("FLEET_TRUCKS_ON_TRIP")} <span>04</span>
            </p>
            <p
              onClick={() => setTrackingtype("available")}
              className={trackingType === "available" ? "active" : "in-active"}
            >
              {t("FLEET_TRUCKS_AVAILABLE")} <span>10</span>
            </p>
          </div>
          {trackingData?.length > 0 ? (
            <div className="truck-list">
              {trackingData.map((truck) => (
                <div className="cards">
                  <div>
                    <Row justify={"space-between"} className="card-rows">
                      <Col className="truck-no">
                        <span>{t("FLEET_TRUCKS_TRUCK_NO")}</span>
                        <span>{truck.number}</span>
                      </Col>
                      <Col className="truck-item">{truck.truckItem}</Col>
                    </Row>
                    <Row justify={"space-between"} className="card-rows">
                      <Col className="column-span">
                        <span>{t("FLEET_TRUCKS_DRIVER_NAME")}</span>
                        <span className="diff-font-size">
                          {truck.driverName}
                        </span>
                      </Col>
                      <Col className="column-span">
                        <span>{t("FLEET_TRUCKS_CONTACT_NO")}</span>
                        <span
                          className="diff-font-size"
                          style={{
                            color: "var(--text-subtle, #545D69B2)",
                            textDecoration: "underline",
                          }}
                        >
                          {truck.contact}
                        </span>
                      </Col>
                    </Row>

                    <div className="bottom-border"></div>

                    <Row justify={"space-between"} className="card-rows">
                      <Col className="truck-id">{truck.truckId}</Col>
                      <Col className="stage">{truck.truckstage}</Col>
                    </Row>
                    <Row justify={"space-between"}>
                      <Col className="column-span">
                        <span>From</span>
                        <span className="diff-font-size">{truck.from}</span>
                      </Col>
                      <Col className="column-span">
                        <span>To</span>
                        <span className="diff-font-size">{truck.to}</span>
                      </Col>
                    </Row>
                    <div className="bottom-border"></div>
                    <Row justify={"space-between"} className="card-rows">
                      <Col>
                        <span className="location-span">
                          <img src={currentLocation} alt="alt" />{" "}
                          {t("FLEET_TRUCKS_CURRENT_LOCATION")}:{" "}
                          {truck.currentLocation}
                        </span>
                      </Col>
                      <Col>
                        <span className="location-span">
                          <img src={movingCircle} alt="alt" />
                          {t("SUPPLIER_MOVING_TEXT")}
                        </span>
                      </Col>
                    </Row>
                  </div>
                  <Row className="last-update-track">
                    {" "}
                    <img src={clockImg} alt="alt" />{" "}
                    {t("FLEET_TRUCKS_LAST_UPDATED")}: {truck.lastUpdated}
                  </Row>
                </div>
              ))}
            </div>
          ) : (
            <Row justify={"center"} className="no-data">
              <img src={NodataImg} alt="no data" />
            </Row>
          )}
        </div>
      )}
      {addSupplierModalOpen && (
        <AddSupplier
          isOpen={addSupplierModalOpen}
          setIsOpen={setAddSupplierModalOpen}
          onClose={handleCloseModal}
          refresh={getSupplierData.bind(this)}
          setSupplierData={setSupplierData}
        />
      )}
    </div>
  );
};

export default Supplier;
